module.exports = __webpack_public_path__ + "img/gifta-logo-black.cc0a942.svg";